export const truncateString = (description: string, maxLength: number) => {
  if (typeof description !== "string") {
    return "";
  }
  if (description.length > maxLength) {
    return description.slice(0, maxLength) + "...";
  }
  return description;
};
